var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-container",class:_vm.classSelected,on:{"click":_vm.exec}},[_c('icon',{attrs:{"icon":_vm.icon}}),_c('icon-caption',{attrs:{"caption":_vm.caption}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }